<div class="app-paginator">
  <a class="arrows" (click)="goToStart()"><<</a>
  <a class="arrows" (click)="goPrev()"><</a>
  @for (p of pagesToDisplay(); track $index) {
    <a
      [appAnimate]="'fadeInUp'"
      [speed]="'fast'"
      [delay]="'' + 40 * $index"
      [ngClass]="{ active: p === activePage() }"
      (click)="activePage.set(p); setPagesToDisplay()"
      >{{ p }}</a
    >
  }
  <a class="arrows" (click)="goNext()">></a>
  <a class="arrows" (click)="goToEnd()">>></a>
</div>
